import auth from "./auth";
import api from "./api";

const BASE_SERVICE_URL = "organization-service";

export default {
    getBranches() {
        return new Promise((resolve, reject) => {
            api.get(BASE_SERVICE_URL + "/branch/list", auth.getHeader())
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },
    getOfflineCapabilitiesSettings() {
        return new Promise((resolve, reject) => {
            api.get(
                    `${BASE_SERVICE_URL}/api/cms/fulfillment-settings/offline-capabilities`,
                    auth.getHeader()
                )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },
    saveOfflineCapabilitiesSettings(payload) {
        return new Promise((resolve, reject) => {
            api.post(
                    `${BASE_SERVICE_URL}/api/cms/fulfillment-settings/offline-capabilities/save`,
                    payload,
                    auth.getHeader()
                )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    }
};
